import React, { Component, useEffect, useState } from 'react';
import { Route, Link, NavLink, withRouter } from "react-router-dom";
import MapView from './MapView';
import BookmarkButton from './BookmarkButton';
import StickyWatcher from './StickyWatcher';
import _ from 'underscore';

import config from './../config';
import helpers from './../utils/helpers';

class OrnefniSearchList extends Component {

	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/oleit/';

		this.state = {
			data: []
		}
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.searchString != prevProps.searchString ||
			this.props.page != prevProps.page ||
			this.props.sysla != prevProps.sysla ||
			this.props.sveitarfelag != prevProps.sveitarfelag ||
			this.props.hreppur != prevProps.hreppur ||
			this.props.tegund != prevProps.tegund
		) {
			this.fetchData();
		}
	}

	fetchData() {
		window.scrollTo(0, 0);

		this.setState({
			notFound: false,
			fetching: true
		});

		let urlParams = helpers.createUrlParams(this.props);

		urlParams.push('limit='+config.pageSize);

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json.results,
					count: json.count,
					notFound: json.results.length == 0,
					fetching: false,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultsCount: json.count
				});

				if (this.props.onResults) {
					this.props.onResults(json);
				}
			}.bind(this));
	}

	render() {
		let pageButtons = [];

		let maxButtonCount = 7;

		let startPage = parseInt(this.props.page || 1);

		if (startPage > Math.floor(maxButtonCount/2) && this.state.resultsCount/config.pageSize > maxButtonCount) {
			startPage = startPage-(Math.floor(maxButtonCount/2));
		}
		else {
			startPage = 1;
		}

		let maxPageCount = Math.ceil((this.state.resultsCount/config.pageSize))+1;

		maxPageCount = maxPageCount > startPage+maxButtonCount ? startPage+maxButtonCount : maxPageCount;
		maxPageCount = maxPageCount > this.state.resultsCount/config.pageSize ? Math.ceil(this.state.resultsCount/config.pageSize) : maxPageCount;

		if (startPage > 1) {
			pageButtons.push(
				<div key="1" className="page-item">
					<NavLink className="page-link btn-info" to={helpers.buildUrl('ornefni', Object.assign(Object.assign({}, this.props), {page: 1}))} aria-label="Previous">
						<span aria-hidden="true">1</span>
					</NavLink>
				</div>
			);

			if (startPage > 2) {
				pageButtons.push(
					<div key="..." className="page-item">
						<div className="page-link btn-info">
							<span aria-hidden="true">...</span>
						</div>
					</div>
				);
			}
		}

		for (let i = startPage; i<maxPageCount; i++) {
			pageButtons.push(
				<div key={i} className="page-item">
					<NavLink className="page-link btn-info" to={helpers.buildUrl('ornefni', Object.assign(Object.assign({}, this.props), {page: i}))} aria-label="Previous">
						<span aria-hidden="true">{i}</span>
					</NavLink>
				</div>
			);
		}

		if (Math.ceil(this.state.resultsCount/config.pageSize) > maxPageCount) {
			pageButtons.push(
				<div key="...." className="page-item">
					<div className="page-link btn-info">
						<span aria-hidden="true">...</span>
					</div>
				</div>
			);
		}

		pageButtons.push(
			<div key={Math.ceil((this.state.resultsCount/config.pageSize))} className="page-item">
				<NavLink className="page-link btn-info" to={helpers.buildUrl('ornefni', Object.assign(Object.assign({}, this.props), {page: Math.ceil(this.state.resultsCount/config.pageSize)}))} aria-label="Previous">
					<span aria-hidden="true">{Math.ceil((this.state.resultsCount/config.pageSize))}</span>
				</NavLink>
			</div>
		);

		let paginationLinks = <React.Fragment>
			{
				this.state.prevUrl &&
				<div className="page-item">
					<Link className="page-link btn-info" to={helpers.buildUrl('ornefni', Object.assign(Object.assign({}, this.props), {page: (this.props.page ? (parseInt(this.props.page)-1) : '')}))} aria-label="Previous">
						<span aria-hidden="true"><span className="arrows">&laquo;</span> Fyrri síða</span>
						<span className="sr-only">Fyrri síða</span>
					</Link>
				</div>
			}
			{
				pageButtons
			}
			{
				this.state.nextUrl &&
				<div className="page-item">
					<Link className="page-link btn-info" to={helpers.buildUrl('ornefni', Object.assign(Object.assign({}, this.props), {page: (this.props.page ? (parseInt(this.props.page)+1) : 2)}))} aria-label="Next">
						<span aria-hidden="true">Næsta síða <span className="arrows">&raquo;</span></span>
						<span className="sr-only">Næsta síða</span>
					</Link>
				</div>
			}
		</React.Fragment>;

		return <React.Fragment>
			<table className={'table table-responsive'+(this.state.fetching ? ' loading' : '')} width="100%">
				<thead>
					<tr>
						<th>Örnefni</th><th></th><th>Bær</th><th>Skrá</th><th></th><th>Tegund</th><th>Skrásetjari</th><th>Ártal</th>
					</tr>
				</thead>
				<tbody>
					{
						this.state.notFound &&
						<tr><td colSpan="3" className="text-center">Ekkert fannst</td></tr>
					}
					{
						this.state.data.map((item, index) => {
							//let baerString = (() => {
							//	return item.ornefnaskra.baeir && item.ornefnaskra.baeir.map ? item.ornefnaskra.baeir.map((baer) => baer.baejarnafn+', '+baer.sveitarfelag.nafn+', '+baer.sysla.nafn) : []
							//})().join('; ');


							//baerString = baerString.length > 100 ? baerString.substr(0, 100)+'...' : baerString;

							return <React.Fragment key={index}>
								{
									item.ornefnaskrar.filter(skra => skra.ornefnaskra).map((ornefnaskra, sIndex) => {
										let baerString;
										if (ornefnaskra.ornefnaskra && ornefnaskra.ornefnaskra.baeir && ornefnaskra.ornefnaskra.baeir.map) {
											let groupedByDistrict = _.groupBy(ornefnaskra.ornefnaskra.baeir, (baer) => (baer.hreppur ? baer.hreppur.nafn : '')+', '+(baer.sysla ? baer.sysla.nafn.replace(/(.*?)a$/,'$1u') : ''));
			
											let farmsInDistrict = [];
			
											for (let district in groupedByDistrict) {
												farmsInDistrict.push(groupedByDistrict[district].map((baer) => baer.baejarnafn+'<br />').join(' ')+'<i>'+district+'</i>')
											}
			
											baerString = farmsInDistrict.join('; ');
										}
										else {
											baerString = '';
										}
			
										return <React.Fragment key={sIndex}>
											<tr className={sIndex > 0 ? 'borderless' : ''}>
												<td>
													{
														sIndex == 0 && <strong><Link to={'/ornefni/'+item.id}>{item.ornefni}</Link></strong>
													}
												</td>
												<td>
													{
														sIndex == 0 && <span className="material-icons md-16 md-dark" title={item.uuid ? 'Hnitsett': 'Óhnitsett'}>{item.uuid ? 'location_on' : ' '}</span>
													}
												</td>
												<td><div dangerouslySetInnerHTML={{__html: baerString}} /></td>
												<td><Link to={'/ornefnaskra/'+ornefnaskra.ornefnaskra.id}>{ornefnaskra.ornefnaskra.titill}</Link></td>
												<td>{
													ornefnaskra.ornefnaskra.stada && ornefnaskra.ornefnaskra.stada.length > 0 &&
													<span>{
														ornefnaskra.ornefnaskra.stada.map((stada, index) => <span className="material-icons-outlined md-16 md-dark md-inactive" title={stada.id == 3 ? 'Yfirfarið': 'Í vinnslu'}>{stada.id == 3 ? 'check_circle' : 'circle'}</span>).reduce((prev, curr) => [prev, ', ', curr])
													} </span>
												}</td>
												<td>{
													ornefnaskra.ornefnaskra.tegund && ornefnaskra.ornefnaskra.tegund.length > 0 &&
													<span>{
														ornefnaskra.ornefnaskra.tegund.map((tegund, index) => <span>{tegund.tegund}</span>).reduce((prev, curr) => [prev, ', ', curr])
													} </span>
												}</td>

												<td>{ornefnaskra.ornefnaskra.skrasetjari && ornefnaskra.ornefnaskra.skrasetjari.nafn ? ornefnaskra.ornefnaskra.skrasetjari.nafn : '-'}</td>
												<td>{ornefnaskra.ornefnaskra.artal.artal_skrar ? ornefnaskra.ornefnaskra.artal.artal_skrar : '-'}</td>
											</tr>
											{
												ornefnaskra.skra_texti && <tr className={'borderless'}>
													<td></td>
													<td></td>
													<td colSpan={6}><small dangerouslySetInnerHTML={{__html: ornefnaskra.skra_texti}} /></td>
												</tr>
											}
										</React.Fragment>
									})
								}

							</React.Fragment>
						})
					}
				</tbody>
			</table>
			{
				(this.state.prevUrl || this.state.nextUrl) && this.state.data.length > 0 &&
				<div className="mb-3">
					<div className="pagination">
						{paginationLinks}
					</div>
				</div>
			}
			</React.Fragment>;
	}
}

class BaeirSearchList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/bleit/';

		this.state = {
			data: []
		}
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.searchString != prevProps.searchString ||
			this.props.page != prevProps.page ||
			this.props.sysla != prevProps.sysla ||
			this.props.sveitarfelag != prevProps.sveitarfelag ||
			this.props.hreppur != prevProps.hreppur ||
			this.props.tegund != prevProps.tegund
		) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			notFound: false,
			fetching: true
		});

		let urlParams = helpers.createUrlParams(this.props);

		urlParams.push('limit='+config.pageSize);

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json.results,
					notFound: json.results.length == 0,
					fetching: false,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultsCount: json.count
				});
				if (this.props.onResults) {
					this.props.onResults(json);
				}
			}.bind(this));
	}

	render() {
		return <React.Fragment>
			<table className={'table table-responsive'+(this.state.fetching ? ' loading' : '')} width="100%">
				<thead>
					<tr>
						<th>Bær</th><th>Sveitarfélag</th><th>Hreppur</th><th>Sýsla</th>
					</tr>
				</thead>
				<tbody>
					{
						this.state.notFound &&
						<tr><td colSpan="3" className="text-center">Ekkert fannst</td></tr>
					}
					{
						this.state.data.map((item, index) => <tr key={index}>
							<td><strong><Link to={'/baer/'+item.id}>{item.baejarnafn}</Link></strong>{(item.tegund && item.tegund.id != 1 ? ' ('+item.tegund.tegund+')' : '')}</td>
							<td>{(item.sveitarfelag ? item.sveitarfelag.nafn : '')}</td>
							<td>{(item.hreppur ? item.hreppur.nafn : '')}</td>
							<td>{item.sysla.nafn.replace(/(.*?)a$/,'$1u')}</td>
						</tr>)
					}
				</tbody>
			</table>
		</React.Fragment>;
	}
}

class GreinarSearchList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/greinar/';

		this.state = {
			data: []
		}
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.searchString != prevProps.searchString ||
			this.props.page != prevProps.page ||
			this.props.sysla != prevProps.sysla ||
			this.props.sveitarfelag != prevProps.sveitarfelag ||
			this.props.hreppur != prevProps.hreppur ||
			this.props.tegund != prevProps.tegund
		) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			notFound: false,
			fetching: true
		});

		let urlParams = helpers.createUrlParams(this.props);

		urlParams.push('limit='+config.pageSize);

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json.results,
					notFound: json.results.length == 0,
					fetching: false,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultsCount: json.count
				});
				if (this.props.onResults) {
					this.props.onResults(json);
				}
			}.bind(this));
	}

	render() {
		return <React.Fragment>
			<table className={'table table-responsive'+(this.state.fetching ? ' loading' : '')} width="100%">
				<thead>
					<tr>
						<th>Titill</th><th>Bær</th>
					</tr>
				</thead>
				<tbody>
					{
						this.state.notFound &&
						<tr><td colSpan="3" className="text-center">Ekkert fannst</td></tr>
					}
					{
						this.state.data.map((item, index) => <tr key={index}>
							<td><strong><Link to={'/grein/'+item.id}>{item.title}</Link></strong></td><td>{ item.baeir.length > 0 && <Link to={'/baer/'+item.baeir[0].id}>{item.baeir[0].baejarnafn}</Link> }</td>
						</tr>)
					}
				</tbody>
			</table>
		</React.Fragment>;
	}
}

function SyslurSelect(props) {
	const [data, setData] = useState();

	useEffect(() => {
		if (!data) {
			fetch(config.apiRoot+'/syslur/')
				.then((res) => res.json())
				.then((data) => data && data.results ? setData(_.sortBy(data.results, 'nafn')) : null);
		}
	});

	return <select className="form-control" value={props.value || -1} onChange={(event) => {
		if (props.onChange) {
			props.onChange(event.target.value);
		}
	}}>
		<option value={-1}>-</option>
		{
			(props.filterData || data || []).map((item, index) => item ? <option key={index} value={item.id}>{item.nafn}</option> : null)
		}
	</select>
}

function SveitarfelogSelect(props) {
	const [data, setData] = useState();

	useEffect(() => {
		if (!data) {
			fetch(config.apiRoot+'/sveitarfelog/?limit=500')
				.then((res) => res.json())
				.then((data) => data && data.results ? setData(_.sortBy(data.results, 'nafn')) : null);
		}
	});

	return <select className="form-control" value={props.value || -1} onChange={(event) => {
		if (props.onChange) {
			props.onChange(event.target.value);
		}
	}}>
		<option value={-1}>-</option>
		{
			(props.filterData || data || []).map((item, index) => item && <option key={index} value={item.id}>{item.nafn}</option>)
		}
	</select>
}

function HrepparSelect(props) {
	const [data, setData] = useState();

	useEffect(() => {
		if (!data) {
			fetch(config.apiRoot+'/hreppar/?limit=500')
				.then((res) => res.json())
				.then((data) => data && data.results ? setData(_.sortBy(data.results, 'nafn')) : null);
		}
	});

	return <select className="form-control" value={props.value || -1} onChange={(event) => {
		if (props.onChange) {
			props.onChange(event.target.value);
		}
	}}>
		<option value={-1}>-</option>
		{
			(props.filterData || data || []).map((item, index) => item ? <option key={index} value={item.id}>{item.nafn}</option> : null)
		}
	</select>
}

function TegundirSelect(props) {
	const [data, setData] = useState();

	/*useEffect(() => {
		if (!data) {
			fetch(config.apiRoot+'/syslur/')
				.then((res) => res.json())
				.then((data) => data && data.results ? setData(_.sortBy(data.results, 'tegund')) : null);
		}
	});*/

	return <select className="form-control" value={props.value || -1} onChange={(event) => {
		if (props.onChange) {
			props.onChange(event.target.value);
		}
	}}>
		<option value={-1}>-</option>
		{
			(props.filterData || data || []).map((item, index) => <option key={index} value={item.id}>{item.tegund}</option>)
		}
	</select>
}

class SearchOverview extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: 'ornefni',
			maximizeResults: false,
			mapData: null,
			filtersVisible: false
		};
	}

	componentDidMount() {
		this.setState({
			selectedTab: this.props.match.params.view
		});

		this.fetchFilterData();

		if (this.props.match.params.searchString) {
			//this.fetchResultsCount();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.view != prevProps.match.params.view) {
			this.setState({
				selectedTab: this.props.match.params.view
			});
		}
		if (this.props.match.params.searchString != prevProps.match.params.searchString ||
			this.props.match.params.page != prevProps.match.params.page ||
			this.props.match.params.sysla != prevProps.match.params.sysla ||
			this.props.match.params.sveitarfelag != prevProps.match.params.sveitarfelag ||
			this.props.match.params.hreppur != prevProps.match.params.hreppur ||
			this.props.match.params.tegund != prevProps.match.params.tegund
		) {
			this.fetchFilterData();
			//this.fetchResultsCount();
		}
	}

	fetchFilterData() {
		let urlParams = helpers.createUrlParams(this.props.match.params);

		urlParams.push('limit='+config.pageSize);

		fetch(config.apiRoot+'/siur/'+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					filterData: json
				});
			}.bind(this));
	}

	render() {
		return (
			<React.Fragment>
				<div className={'row boxes'+(this.state.maximizeResults ? ' maximize-results' : '')}>

					<div className={'filters-column col col-12 col-md-3'}>

						<button className="btn btn-secondary d-sm-none" onClick={() => this.setState({
							filtersVisible: !this.state.filtersVisible
						})}>Sía niðurstöður</button>

						<div className={'form-group'+(this.state.filtersVisible ? ' open' : '')}>

							<label>Sía eftir sýslu:</label>
							<SyslurSelect value={this.props.match.params.sysla}
								filterData={this.state.filterData && this.state.filterData[this.state.selectedTab+'_syslur'] ? this.state.filterData[this.state.selectedTab+'_syslur'].map((item) => item.sysla) : null}
							 	onChange={(value) => {
									let params = Object.assign({}, this.props.match.params);
									params.sysla = value == -1 ? undefined : value;

									this.props.history.push(helpers.buildUrl(this.props.match.params.view, params));
								}}/>

							<hr/>

							<label>Sía eftir hreppi:</label>
							<HrepparSelect value={this.props.match.params.hreppur}
								filterData={this.state.filterData && this.state.filterData[this.state.selectedTab+'_hreppar'] ? this.state.filterData[this.state.selectedTab+'_hreppar'].map((item) => item.hreppur) : null}
							 	onChange={(value) => {
									let params = Object.assign({}, this.props.match.params);
									params.hreppur = value == -1 ? undefined : value;
									params.sveitarfelag = undefined;
									this.props.history.push(helpers.buildUrl(this.props.match.params.view, params));
								}}/>

							<hr/>

							<label>Sía eftir sveitarfélagi:</label>
							<SveitarfelogSelect value={this.props.match.params.sveitarfelag}
								filterData={this.state.filterData && this.state.filterData[this.state.selectedTab+'_sveitarfelog'] ? this.state.filterData[this.state.selectedTab+'_sveitarfelog'].map((item) => item.sveitarfelag) : null}
							 	onChange={(value) => {
									let params = Object.assign({}, this.props.match.params);
									params.sveitarfelag = value == -1 ? undefined : value;
									params.hreppur = undefined;
									this.props.history.push(helpers.buildUrl(this.props.match.params.view, params));
								}}/>

							{
								(this.state.selectedTab == 'ornefni' || this.state.selectedTab == 'kort') &&
								<React.Fragment>
									<hr/>

									<label>Sía eftir tegund örnefnaskrár:</label>
									<TegundirSelect value={this.props.match.params.tegund}
										filterData={this.state.filterData && this.state.filterData['ornefni_tegundir'] ? _.compact(this.state.filterData['ornefni_tegundir']) : null}
										onChange={(value) => {
											let params = Object.assign({}, this.props.match.params);
											params.tegund = value == -1 ? undefined : value;
											this.props.history.push(helpers.buildUrl(this.props.match.params.view, params));
										}}/>
								</React.Fragment>
							}

						</div>
					</div>

					<div className={'results-column col col-12 col-md-9'}>
						<div className="column-content no-padding">
							<div className="tabs-wrapper">
								<StickyWatcher className="column-heading sticky" useBodyTag={false} stickyClassName="is-sticky">
									<strong>Leitarniðurstöður <a className="d-sm-block d-none float-right btn btn-primary badge badge-secondary" onClick={() => {
										this.setState({
											maximizeResults: !this.state.maximizeResults
										});
									}}>{this.state.maximizeResults ? 'Minnka' : 'Stækka'}</a></strong>

									<ul className="nav nav-tabs">
										<li className="nav-item">
											<Link to={helpers.buildUrl('ornefni', this.props.match.params, ['sida', 'tegund'])} className={'nav-link'+(this.state.selectedTab == 'ornefni' ? ' active' : '')} >{'Örnefni'+(this.state.ornefniCount ? ' ('+this.state.ornefniCount+')' : ' (0)')}</Link>
										</li>
										<li className="nav-item">
											<Link to={helpers.buildUrl('baeir', this.props.match.params, ['sida', 'tegund'])} className={'nav-link'+(this.state.selectedTab == 'baeir' ? ' active' : '')}>{'Bæir'+(this.state.baeirCount ? ' ('+this.state.baeirCount+')' : ' (0)')}</Link>
										</li>
										<li className="nav-item">
											<Link to={helpers.buildUrl('greinar', this.props.match.params, ['sida', 'tegund'])} className={'nav-link'+(this.state.selectedTab == 'greinar' ? ' active' : '')}>{'Greinar'+(this.state.greinarCount ? ' ('+this.state.greinarCount+')' : ' (0)')}</Link>
										</li>
										<li className="nav-item">
											<Link to={helpers.buildUrl('kort', this.props.match.params, ['sida', 'tegund'])} className={'nav-link'+(this.state.selectedTab == 'kort' ? ' active' : '')}>Kort</Link>
										</li>
									</ul>
								</StickyWatcher>

								<div className="tabs-content padding-25">

									<Route exact path="/leit/(ornefni|baeir|greinar)/:searchString*(/sida/)?:page*(/sysla/)?:sysla*(/hreppur/)?:hreppur*(/sveitarfelag/)?:sveitarfelag*" render={(routeProps) => (
										<div className={'tab'+(this.state.selectedTab == 'ornefni' ? ' visible' : '')}>
											<OrnefniSearchList onResults={(event) => this.setState({ornefniCount: event.count})} {...this.props.match.params} />
										</div>
									)}/>

									<Route exact path="/leit/(ornefni|baeir|greinar)/:searchString*(/sida/)?:page*(/sysla/)?:sysla*(/hreppur/)?:hreppur*(/sveitarfelag/)?:sveitarfelag*" render={(routeProps) => (
										<div className={'tab'+(this.state.selectedTab == 'baeir' ? ' visible' : '')}>
											<BaeirSearchList onResults={(event) => this.setState({baeirCount: event.count})} {...this.props.match.params} />
										</div>
									)}/>

									<Route exact path="/leit/(ornefni|baeir|greinar)/:searchString*(/sida/)?:page*(/sysla/)?:sysla*(/hreppur/)?:hreppur*(/sveitarfelag/)?:sveitarfelag*" render={(routeProps) => (
										<div className={'tab'+(this.state.selectedTab == 'greinar' ? ' visible' : '')}>
											<GreinarSearchList onResults={(event) => this.setState({greinarCount: event.count})} {...this.props.match.params} />
										</div>
									)}/>

									<div className={'tab'+(this.state.selectedTab == 'kort' ? ' visible' : '')}>
										<MapView viewInTabs={true}
											selectedTab={this.state.selectedTab}
											maximized={this.state.maximizeResults}
											searchParams={this.props.match.params}
											mapData={this.state.mapData}
											overlayListData={this.state.mapData}
										/>
									</div>

								</div>
							</div>
						</div>
					</div>

				</div>
			</React.Fragment>
		);
	}
}

export default withRouter(SearchOverview);



// WEBPACK FOOTER //
// ./src/components/SearchOverview.js